<li class="list-group-item" :class="styles"><Checkbox class="right-check" v-model="checked"></Checkbox><i class="fa fa-file-o"></i>
{{ page.title }}</li>